import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { MealType, UserType } from '../../../common/commonTypes';
import { checkMeals } from '../helpers';
import { analyzeMeal } from '../../../api';
// import MealInput from './MealInput';
import MealInput2 from './MealInput2';
import ModalSaveMeal from '../../ModalSaveMeal';
import BarCodeScanModal from './BarCodeScanModal';
import { AlertTitle } from '@mui/lab';
import { Trans, useTranslation } from 'react-i18next';
import CameraModal from './CameraModal';

type DailySummaryType = {
    user: UserType;
    refresh: () => void;
};

const Submission = (props: DailySummaryType) => {
    const { user, refresh } = props;

    const { t, i18n } = useTranslation();

    // const confirmedMeals00: MealType[] = [
    //     {
    //         name: "111",
    //         weight: 20,
    //         calories: 90,
    //         protein: 25,
    //         fats: 0,
    //         carbsNoSugars: 0,
    //         sugars: 0,
    //         // userId: user.id,
    //         // date: DateTime.local().toUTC().toISO(),
    //     },
    //     {
    //         name: "222",
    //         weight: 20,
    //         calories: 90,
    //         protein: 25,
    //         fats: 0,
    //         carbsNoSugars: 0,
    //         sugars: 0,
    //         // userId: user.id,
    //         // date: DateTime.local().toUTC().toISO(),
    //     },
    //     {
    //         name: "33",
    //         weight: 20,
    //         calories: 90,
    //         protein: 25,
    //         fats: 0,
    //         carbsNoSugars: 0,
    //         sugars: 0,
    //         // userId: user.id,
    //         // date: DateTime.local().toUTC().toISO(),
    //     }
    // ];
    //
    // const [confirmedMeals, setConfirmedMeals] = useState<MealType[]>(confirmedMeals00);

    const [showBarCodeScanner, setShowBarCodeScanner] = useState(false);
    const [showCameraModal, setShowCameraModal] = useState(false);
    const [analyzing, setAnalyzing] = useState<boolean>(false);
    const [confirmedMeals, setConfirmedMeals] = useState<MealType[]>([]);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleAnalyzeMeal = async (meal: string) => {
        setErrorMessage(null);
        setAnalyzing(true);
        try {
            const res = await analyzeMeal(meal);
            setAnalyzing(false);
            const validMeals = checkMeals(res.data);
            if (!validMeals || !validMeals.length) {
                console.error('No valid meals');
                setErrorMessage('CPE_AI_RESPONSE_FROM_ANALYZER_HAS_NULLS');
            } else {
                setConfirmedMeals(validMeals);
            }
        } catch (error) {
            setAnalyzing(false);
            alert('Error analyzing input. Try again'); // todo ERROR BANNER
            console.error('Error analyzing meals', error);
        }
    };

    const handleCancelSaving = () => {
        setConfirmedMeals([]);
    };

    const handleSuccessSaving = () => {
        setSuccessMessage(
            `${confirmedMeals.length} ${t('SUCCESS_MSG_num_of_meals_added_for_today')}`
        );
        setConfirmedMeals([]);
        refresh();
    };

    return (
        <>
            {/*<MealInput analyzing={analyzing} handleAnalyzeMeal={handleAnalyzeMeal} />*/}
            <MealInput2
                user={user}
                analyzing={analyzing}
                handleAnalyzeMeal={handleAnalyzeMeal}
                showBarCodeScanner={() => {
                    setShowBarCodeScanner(true);

                    window.gtag?.('event', 'show bar code scanner', {});
                }}
                showCameraModal={() => {
                    setShowCameraModal(true);
                    window.gtag?.('event', 'show camera modal', {});

                    if (user.settings.userType === 'prime') {
                        //  TODO: SHOW INTERSTITIAL OR BANNER
                    }
                }}
            />

            {showBarCodeScanner && (
                <BarCodeScanModal
                    onCancel={() => {
                        setShowBarCodeScanner(false);
                    }}
                    onSuccess={(mealToSave) => {
                        setConfirmedMeals([mealToSave]);
                        setShowBarCodeScanner(false);
                    }}
                />
            )}

            {showCameraModal && (
                <CameraModal
                    onCancel={() => {
                        setShowCameraModal(false);
                    }}
                    onSuccess={(mealsToSave: MealType[]) => {
                        setConfirmedMeals(mealsToSave);
                        setShowCameraModal(false);
                    }}
                />
            )}

            {Boolean(confirmedMeals.length) && (
                <ModalSaveMeal
                    user={user}
                    meals={confirmedMeals}
                    actionType="LOG_MEALS"
                    onSuccess={handleSuccessSaving}
                    onCancel={handleCancelSaving}
                />
            )}

            {/* TODO: ABSTRACT, IMPROVE (err / success states) AND REUSE  */}
            {successMessage && (
                <Snackbar
                    // anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open
                    autoHideDuration={3000}
                    onClose={() => {
                        setSuccessMessage(null);
                    }}
                    message={successMessage}
                />
            )}

            {errorMessage && (
                <Alert
                    variant="filled"
                    severity="warning"
                    onClose={() => {
                        setErrorMessage(null);
                    }}
                    style={{
                        position: 'absolute',
                        top: '66px',
                        left: '15px',
                        right: '15px',
                    }}
                >
                    <AlertTitle>{t('cant_recognize_meal')}</AlertTitle>
                    <p className="font-normal">
                        <Trans i18nKey="cant_recognize_meal_description" />
                    </p>
                </Alert>
            )}
        </>
    );
};

export default Submission;
